import axios from "axios";

axios.defaults.withCredentials = true;

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export default axios;
